import React, { useState } from 'react'

import { Menu, Dropdown } from 'antd'
import { CgDetailsMore } from 'react-icons/cg'
import { AiOutlineMore } from 'react-icons/ai'
import { userTypes } from '../../../common/UserType' 
import { EditCatagory } from '../../service/catagory/EditCatagory' 
import { ConfirmDeleteRequest } from '../../shared/ConfirmDeleteRequest'

export const ServiceOption = ({ record, userType,DeleteOption }) => {
    
    const idd = record.id

    const [visible, setVisible]=useState(false)
    const [editVisible, setEditVisible]=useState(false)

    const handleVerify = () =>{
        setVisible(true)
    }
    const handleCancel = () => {
        setVisible(false)
        setEditVisible(false)
    }

    const menu = (
        <Menu style={{ width: 140 }}>
            {
                userType === userTypes.CLIENTS &&
                <div>
                    <Menu.Item key="1">
                        <div className='flex items-center' >
                            <div className='flex flex-col'>
                                <div className='px-4 py-2 shadow-md hover:shadow-lg flex flex-row'>
                                    <CgDetailsMore />
                                    <button onClick={handleVerify}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Menu.Item>
                </div>
            }
            <Menu.Divider />
        </Menu>
    )

    return (

        <div className='flex flex-col'>
            {
                visible &&
                <ConfirmDeleteRequest
                    visible={visible}
                    onCancel={handleCancel}
                    // handleOk={handleDeleteClientsSubmit}
                    title="Delete client"
                    okText="Delete"
                    warningText="Are you sure to delete this client"
                    user={record}
                />                
            }
            {
                editVisible &&
                <EditCatagory
                    visible={editVisible}
                    handleCancel={handleCancel}
                    clients={record}
                />
            
            }

            <div className='flex flex-col cursor-pointer w-full items-center justify-center' >
                <Dropdown overlay={menu} trigger={['click']} placement="bottomCenter" key={idd}>
                    <span className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                        <AiOutlineMore className='w-7 h-7' />
                    </span>
                </Dropdown>
            </div>
        </div>
    )
}
